import {
  BrandPlanContents,
  BrandPlanTactic,
  BrandPlanTacticContents,
  CrosspostFrequency,
  PostContentType,
  WeekDays,
} from 'types'
import { CountInputProps } from 'components/Wizards/CountInput/Types'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'

export const CROSSPOST_RELEVANT_TACTICS: Record<'crosspost_contents' | 'video_crosspost_contents', BrandPlanTactic[]> =
  {
    crosspost_contents: [
      BrandPlanTactic.Instagram,
      BrandPlanTactic.Facebook,
      BrandPlanTactic.Twitter,
      BrandPlanTactic.LinkedIn,
      BrandPlanTactic.GoogleBusinessProfile,
    ],
    video_crosspost_contents: [BrandPlanTactic.InstagramReel, BrandPlanTactic.YouTube, BrandPlanTactic.TikTok],
  }

export interface EditChannelsFormValues extends BrandPlanContents {
  crosspost_frequency: CrosspostFrequency
  tactics: BrandPlanTactic[]
  week_days: WeekDays
  length?: number
  start_date?: string
}

export interface EditChannelsModalProps {
  crosspostFrequency: CrosspostFrequency
  tactics: BrandPlanTactic[]
  instagramContents: BrandPlanTacticContents
  facebookContents: BrandPlanTacticContents
  linkedinContents: BrandPlanTacticContents
  twitterContents: BrandPlanTacticContents
  emailContents: BrandPlanTacticContents
  seoContents: BrandPlanTacticContents
  tiktokContents: BrandPlanTacticContents
  youtubeContents: BrandPlanTacticContents
  crosspostContents: BrandPlanTacticContents
  videoCrosspostContents: BrandPlanTacticContents
  googleMyBusinessContents: BrandPlanTacticContents
  length: number
  weekDays: WeekDays
  startDate: string
  onSubmit: (values: EditChannelsFormValues) => void
}

export interface ContentCountInputProps extends Omit<CountInputProps, 'value' | 'onChange'> {
  merged?: boolean
}

export interface AccountProps {
  integration: ExternalIntegration
  size?: number
}

export interface UsePostTypeFieldProps {
  name: string
  postType: 'reel' | 'story' | 'post' | 'short' | 'newsletter' | 'blog_post'
  accountId?: number
  contentType?: PostContentType | null
}

export interface PostTypeCountInputProps extends ContentCountInputProps, UsePostTypeFieldProps {}
